import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  List,
  ListItemButton,
  ListItemText,
  ListItemIcon,
  FormHelperText,
} from '@mui/material';
import BranchListItem from './BranchListItem';
import BranchesMenu from './BranchesMenu';

const BranchesAccordion = function BranchesAccordion({
  error = {},
  allBranches = [],
  defaultBranch = '',
  selectedBranches = [],
  handleAddBranchToUser = () => {},
  handleRemoveBranchToUser = () => {},
  handleChangeDefaultBranch = () => {},
}) {
  const intl = useIntl();
  const [branchesMenu, setBranchesMenu] = useState(null);
  const { message = null } = error || {};
  /**Menu open/close functions**/
  const handleOpenBranchesMenu = (event) => {
    setBranchesMenu(event.currentTarget);
  };
  const handleCloseBranchesMenu = () => {
    setBranchesMenu(null);
  };
  /****/

  return (
    <>
      <div>
        <FormHelperText
          sx={{
            whiteSpace: 'noWrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            color: 'error.main',
          }}
        >
          {message}
        </FormHelperText>
        <Accordion sx={{ minHeight: '56px' }} defaultExpanded>
          <AccordionSummary
            id="branches-list-accordion"
            aria-controls="open-branches-list-acc"
            expandIcon={<ExpandMoreIcon />}
          >
            <Typography>{intl.messages.BRANCHES}</Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ padding: '8px 0px' }}>
            <List>
              {selectedBranches.map((branch, index) => (
                <BranchListItem
                  key={`${branch.id}-${index}`}
                  branch={branch}
                  isDefault={defaultBranch === branch.id}
                  onSwitchClick={() => handleChangeDefaultBranch(branch.id)}
                  onRemoveClick={() => handleRemoveBranchToUser(branch.id)}
                />
              ))}
              <ListItemButton
                alignItems="center"
                onClick={handleOpenBranchesMenu}
              >
                <ListItemIcon>
                  <AddCircleRoundedIcon />
                </ListItemIcon>
                <ListItemText primary={intl.messages.ADD_BRANCH} />
              </ListItemButton>
            </List>
          </AccordionDetails>
        </Accordion>
      </div>
      <BranchesMenu
        anchor={branchesMenu}
        onClose={handleCloseBranchesMenu}
        branches={allBranches}
        onClickBranch={handleAddBranchToUser}
      />
    </>
  );
};

BranchesAccordion.propTypes = {
  error: PropTypes.object,
  allBranches: PropTypes.array,
  defaultBranch: PropTypes.string,
  handleAddBranchToUser: PropTypes.func,
  handleRemoveBranchToUser: PropTypes.func,
  handleChangeDefaultBranch: PropTypes.func,
  selectedBranches: PropTypes.array,
};

export default BranchesAccordion;
